// message.js
import React from 'react';
import PropTypes from 'prop-types';
import './Message.scss';
import { formatMessageContent } from '../utils/utils.js';

const Message = ({ message, isLastUserMessage }) => {

  return (
      <div className={`message ${message.sender}`}>
        {message.sender === "You" ? message.text : formatMessageContent(message.text)}
      </div>
  );
};

Message.propTypes = {
  message: PropTypes.shape({
    sender: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })
};

export default Message;
